import { bool, string, node, any, func, shape, oneOfType, arrayOf } from "prop-types";
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import useStyle from "./NavigationSwitch.style";
import classnames from "classnames";

export const NavigationSwitch = ({
  values,
  value,
  onChange,
  className,
  buttonClassName,
  labelClassName,
  lighter,
  line,
  ...props
}) => {
  /** @note: responsiveness? (maybe show them in the column instead of row */
  const classes = useStyle();
  
  return (
    <BottomNavigation
      value={value}
      onChange={onChange}
      role="navigation"
      className={classnames(line && classes.line, className)}
      showLabels
      { ...props }
    >
      {
        values.map(({ value: v, label, ariaLabel: a, className: c }, i) => (
          <BottomNavigationAction
            key={`${v}_${i}`}
            aria-label={ a }
            label={label}
            value={v}
            className={classnames(
              classes.button,
              "max-w-full",
              lighter && classes.lighter,
              lighter && "text-deco-none",
              buttonClassName,
              c,
            )}
            classes={{
              label: labelClassName
            }}
          />
        ))
      }
    </BottomNavigation>
  );
};

NavigationSwitch.propTypes = {
  value: any.isRequired,
  values: arrayOf(
    shape({
      value: any.isRequired,
      label: oneOfType([string, node]),
      ariaLabel: string,
    })
  ),
  onChange: func.isRequired,
  className: string,
  buttonClassName: string,
  labelClassName: string,
  lighter: bool,
  line: bool,
};
